import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ background: '#b91c1c', color: 'white', display: 'inline-block', padding: '12px 24px', borderRadius: 12, fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
            PPE Tracker
          </div>
        </div>

        <div style={{ background: 'white', padding: 32, borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          {submitted ? (
            <>
              <div style={{ textAlign: 'center', marginBottom: 16 }}>
                <div style={{ fontSize: 40, marginBottom: 8 }}>&#9993;</div>
                <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 600 }}>Check Your Email</h2>
                <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.5, margin: 0 }}>
                  If an account exists with <strong>{email}</strong>, we've sent a password reset link. Check your inbox and spam folder.
                </p>
              </div>
              <p style={{ textAlign: 'center', fontSize: 14, color: '#6b7280', marginTop: 20 }}>
                <Link to="/login" style={{ color: '#b91c1c', fontWeight: 500 }}>Back to Sign In</Link>
              </p>
            </>
          ) : (
            <>
              <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 600 }}>Forgot Password?</h2>
              <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 20, lineHeight: 1.4 }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>

              {error && <div style={{ background: '#fef2f2', color: '#b91c1c', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>{error}</div>}

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 6, color: '#374151' }}>Email</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                    placeholder="you@department.com" />
                </div>

                <button type="submit" disabled={loading}
                  style={{ width: '100%', padding: '12px', background: '#b91c1c', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <p style={{ marginTop: 20, textAlign: 'center', fontSize: 14, color: '#666' }}>
                Remember your password? <Link to="/login" style={{ color: '#b91c1c', fontWeight: 500 }}>Sign In</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
